export default __webpack_public_path__ + "static/media/sm.9ca0007a.svg";